<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('all_notifications')" icon="bell"/>
            </div>
        </div>

        <div class="card border-0 card-with-shadow">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{ $t('title') }}</th>
                                <th>{{ $t('body') }}</th>
                                <th>{{ $t('date') }}</th>
                                <th>{{ $t('time') }}</th>
                                <th>{{ $t('action') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in notifications" :key="item.id" :class="{'fw-bold': !item.read_at}">
                                <td>{{ item.title }}</td>
                                <td>{{ textTruncate(item.body, 50) }}</td>
                                <td>{{ formatDate(item.created_at) }}</td>
                                <td>{{ formatTime(item.created_at) }}</td>
                                <td>
                                    <button class="btn btn-sm btn-primary" @click="readNotification(item)">{{ $t('view') }}</button>
                                </td>
                            </tr>
                            <tr v-if="notifications.length === 0 && !loading">
                                <td colspan="5" class="text-center">{{ $t('no_notification_one') }}</td>
                            </tr>
                            <tr v-if="loading">
                                <td colspan="5" class="text-center"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-4" v-if="pagination.last_page > 1">
                    <app-pagination
                        v-show="true"
                        :total-row="pagination.total"
                        :row-limit="pagination.per_page"
                        @submit="fetchNotifications"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from "moment";
    import {getWebUrlFromDeepLink} from "../../../Helpers/Helpers";
    import {externalApiCall, urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "AllNotification",
        data() {
            return {
                notifications: [],
                loading: true,
                pagination: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 10,
                    total: 0
                }
            }
        },
        mounted() {
            this.fetchNotifications(1);
        },
        methods: {
            textTruncate(str, length = 50, ending = '...') {
                if (!str) return '';
                if (str.length > length) {
                    return str.substring(0, length - ending.length) + ending;
                } else {
                    return str;
                }
            },
            formatDate(date) {
                return moment(date).format('DD-MM-YYYY');
            },
            formatTime(date) {
                return moment(date).format('hh:mm A');
            },
            fetchNotifications(page = 1) {
                if(page < 1 || (this.pagination.last_page && page > this.pagination.last_page && page !== 1)) return;
                
                this.loading = true;
                externalApiCall('GET', `/api/notifications?page=${page}&per_page=${this.pagination.per_page}`).then(({data}) => {
                    this.notifications = data.data;
                    this.pagination = data.pagination;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            readNotification(notification) {
                let redirectUrl = notification.deep_link ? urlGenerator(getWebUrlFromDeepLink(notification.deep_link)) : null;
                if(!notification.read_at) {
                    externalApiCall('POST', `/api/notifications/${notification.id}/read`).then(() => {
                        notification.read_at = new Date();
                        this.$store.dispatch('getNotifications');
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    }).catch(() => {
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        }
                    });
                } else {
                    if (redirectUrl) {
                        window.location = redirectUrl;
                    }
                }
            },
        }
    }
</script>
